export default __webpack_public_path__ + "static/media/topbar.57a1207d.svg";